import { AnyResource } from '@models';

export const getParentTypeByResource = (resource: AnyResource) =>
  resource.breadcrumb?.at(-1)?.type ?? null;
